module.exports = __webpack_public_path__ + "img/9d08ba7.png";